import script from "./Index.vue?vue&type=script&lang=ts&setup=true"
export * from "./Index.vue?vue&type=script&lang=ts&setup=true"

import "./Index.vue?vue&type=style&index=0&id=6fa3a6ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fa3a6ae"]])

export default __exports__